module.exports = __webpack_public_path__ + "static/media/aws_activate.cc79402a.png";